import { render, staticRenderFns } from "./RemindForm.vue?vue&type=template&id=74a4d665&scoped=true&"
import script from "./RemindForm.vue?vue&type=script&lang=js&"
export * from "./RemindForm.vue?vue&type=script&lang=js&"
import style0 from "./RemindForm.vue?vue&type=style&index=0&id=74a4d665&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a4d665",
  null
  
)

export default component.exports